$(document).ready(function () {
  const select2Selector = 'select.pg__option__value[aria-label="Size"]';
  $(select2Selector).select2({
    placeholder: "Selecciona una opción",
    minimumResultsForSearch: Infinity,
  }); 

  $(".nuclear_icon a").on("click",function(e) {
    // e.preventDefault();
    $('body').addClass('nuclear');
  })

  document.querySelectorAll('div[data-product-handle="jones-soda-x-crayola-limited-edition-12-pack"] .money').forEach(el => {
    const text = el.textContent.trim().replace(/\s+/g, '');
    const match = text.match(/^(\D*\d+)\.(\d{2})$/);

    if (match) {
      const [_, integerPart, decimalPart] = match;
      el.innerHTML = `${integerPart}.<span class="money-decimals">${decimalPart}</span>`;
    }
  });
  
});


var elem = document.querySelector('.sticker');
if(elem){ 
  window.addEventListener('scroll', function() {
   const sy = window.scrollY || document.documentElement.scrollTop;
    if(sy>200){
    elem.style.transform = `rotate(${sy}deg)`; 
    }
  });
}
let background = document.querySelector(".map-background");
if(background){
  document.addEventListener("scroll", function () {
      let scrollPosition = window.scrollY;
      background.style.backgroundPositionX = scrollPosition * 0.5 + "px";
  });
}